import { render, staticRenderFns } from "./StudiesConfiguration.vue?vue&type=template&id=4197e419&scoped=true&"
import script from "./StudiesConfiguration.vue?vue&type=script&lang=js&"
export * from "./StudiesConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./StudiesConfiguration.vue?vue&type=style&index=0&id=4197e419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197e419",
  null
  
)

export default component.exports